import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AnalyticsService from 'services/analytics';

const Pageview: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    AnalyticsService.logPageview();
  }, [location]);

  return null;
};

export default Pageview;
